const menuOpenButton = document.querySelector('.js-menu-open');
const menuCloseButton = document.querySelector('.js-menu-close');
const menu = document.querySelector('.js-menu');

function onOpen() {
  menu.classList.remove('translate-x-full');
  document.body.classList.add('overflow-hidden');
}
function onClose() {
  menu.classList.add('translate-x-full');
  document.body.classList.remove('overflow-hidden');
}
const events = () => {
  menuOpenButton.addEventListener('click', () => onOpen());
  menuCloseButton.addEventListener('click', () => onClose());
};

const init = () => {
  if (menuOpenButton && menuCloseButton && menu) {
    events();
  }
};

export default {
  init,
};
